import React from "react";
import Loading from "../Loading";

export default function StartBot(props) {
    const [loading, setLoading]  = React.useState(false);

    const start = function() {
        setLoading(true);
        window.open('https://t.me/FormyAgentBot?start=start', '_blank');
    }

    const handleFocus = () => {
        setTimeout(function () {
            setLoading(false);
        }, 1000);
    };
    window.addEventListener('focus', handleFocus);

    return (
        <section className="relative">
            {loading && <Loading/>}
            <section className="p-6">
                <button className="btn btn-default" onClick={start}>
                    Start
                </button>
            </section>
        </section>
    );
}